// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"407":"9c1f0f0a","671":"9c1f0f0a","691":"9c1f0f0a","698":"9c1f0f0a","714":"9c1f0f0a","945":"9c1f0f0a"}[chunkId] + ".chunk.css";
};